import './src/styles/global.css'
import 'swiper/swiper-bundle.min.css'
import React from 'react'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './src/context/AuthContext'

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
    {element}
    <Toaster
      position="top-right"
      toastOptions={{
        style: { fontFamily: 'TekoRegular, Helvetica, sans-serif', fontSize: '18px' },
        success: { iconTheme: { primary: '#FD5A00', secondary: '#fff' } },
      }}
    />
  </AuthProvider>
)